import styled from "styled-components";
import { CalciteH4 } from "calcite-react/Elements";

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
  align-items: center;
  flex-grow: 1;
  overflow: hidden;
`;

const Title = styled(CalciteH4)`
  margin: 0;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ButtonContainer = styled.div`
  white-space: nowrap;
`;

export { HeaderContainer, Title, ButtonContainer };
